import React from 'react';
import { Button } from 'antd';
import styled from 'styled-components';
import { PlusOutlined } from '@ant-design/icons';

import { isNotEmptyValue } from '../../utils/filter';
import ConcatOperatorSelector from './ConcatOperatorSelector';
import FilterClause from './FilterClause';

const StyledFilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;

  .item-container {
    width: 100%;
    display: flex;
    align-items: flex-start;
  }
`;

const StyledFilterClauseContainer = styled.div`
  display: flex;
  width: ${({ index, clausesLength }) =>
    index === 0 || index < clausesLength - 1 ? '100%' : 'calc(100% - 82px)'};
`;

const StyledButton = styled(Button)`
  min-width: 32px;
`;

/**
 * key={index} was added to ConcatOperatorSelector to make force re-render
 * to avoid delay while clause is removing because of transition prop of Select component.
 * [TODO] Think about better fix..
 */
const FilterContainer = ({
  concatOperator,
  clauses,
  metainf,
  zoneId,
  onSetClausesConcatOperator,
  onAddFilterClause,
  excludeGroups = [],
  onRemoveFilterClause,
  onSelectFilterClauseField,
  onSelectFilterClauseOperator,
  onFilterClauseValueChange,
}) => (
  <StyledFilterContainer>
    {clauses.map((clause, index) => (
      <div key={clause.id} className="item-container">
        {clauses.length > 1 && (
          <ConcatOperatorSelector
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            value={concatOperator}
            hidden={!index}
            onSelect={(co) => onSetClausesConcatOperator(co)}
          />
        )}
        <StyledFilterClauseContainer clausesLength={clauses.length} index={index}>
          <FilterClause
            key={clause.id}
            onRemove={() => onRemoveFilterClause(clause.id)}
            onSelectField={(field, type) => onSelectFilterClauseField(clause.id, field, type)}
            onSelectOperator={(operator, resetValue) =>
              onSelectFilterClauseOperator(clause.id, operator, resetValue)
            }
            onValueChange={(value) => onFilterClauseValueChange(clause.id, value)}
            field={clause.field}
            operator={clause.operator}
            value={isNotEmptyValue(clause.value) ? clause.value : undefined}
            metainf={metainf}
            zoneId={zoneId}
            excludeGroups={excludeGroups}
          />
          {index === clauses.length - 1 && (
            <div>
              <StyledButton icon={<PlusOutlined />} onClick={onAddFilterClause} />
            </div>
          )}
        </StyledFilterClauseContainer>
      </div>
    ))}
    {!clauses.length && (
      <Button icon={<PlusOutlined />} onClick={onAddFilterClause}>
        Add filter clause
      </Button>
    )}
  </StyledFilterContainer>
);

export default FilterContainer;
